import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import { listaEventos, criaPagamentoPix } from '../../services/mysql'
import CurrencyInput from 'react-currency-input';

export async function copyToClipboard(text) {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (error) {
        console.error("Erro ao copiar texto:", error);
        return false;
    }
}


export default function Produtos() {
    const [academias, setAcademias] = useState([])
    const [servico, setServico] = useState("")
    const [nome, setNome] = useState("")
    const [email, setEmail] = useState("")
    const [cpf, setCpf] = useState("")
    const [valor, setValor] = useState(0)
    const [chavePix, setChavePix] = useState("")

    function geraPagamento() {
        if (!servico) {
            mensagemAlerta('Escolha o serviço')
            return
        }
        if (nome.length < 10) {
            mensagemAlerta('O nome é obrigatório ')
            return
        }
        if (!email) {
            mensagemAlerta('O email é obrigatório ')
            return
        }
        if (valor === 0) {
            mensagemAlerta('O CPF não pode ser menor ou igual a R$0,00')
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: `Deseja gerar pagamento para ${nome} ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Gerando pagamento Pix')
                const pagamento = {
                    nome: nome,
                    email: email,
                    cpf: cpf,
                    servico: servico,
                    valor: parseFloat(valor)
                }
                criaPagamentoPix(pagamento).then((res) => {
                    Swal.close()
                    setChavePix(res.data.pagamento.chave)
                    mensagemSucesso('Pagamento pix gerado com sucesso')
                })
            }
        });
    }

    const handleCopy = async () => {
        const success = await copyToClipboard(chavePix);
        if (success) {
            mensagemSucesso('Chave Copiada com sucesso')
        }
    };

    const handleServico = (event) => {
        event.persist();
        setServico(event.target.value);
    }
    const handleNome = (event) => {
        event.persist();
        setNome(event.target.value);
    }
    const handleEmail = (event) => {
        event.persist();
        setEmail(event.target.value);
    }
    const handleCpf = (event) => {
        event.persist();
        setCpf(event.target.value);
    }
    function handleValor(event, maskedvalue, floatvalue) {
        setValor(maskedvalue);
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success')
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Serviços Extras</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Gerar Cobrança Pix</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div onsubmit="return false">
                                            <div className="row">
                                                <div class="mb-3 col-md-3">
                                                    <label class="form-label" for="basic-icon-default-fullname">Serviço</label>
                                                    <div class="input-group input-group-merge">
                                                        <select id="defaultSelect" className="form-select" onChange={handleServico} >
                                                            <option>Selecione</option>
                                                            <option value={'Serviço de Hospedagem'}>Serviço de Hospedagem</option>
                                                            <option value={'Serviço de Internet'}>Serviço de Internet</option>
                                                            <option value={'Serviço Digital'}>Serviço Digital</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-md-3">
                                                    <label class="form-label" for="basic-icon-default-fullname">Nome do Devedor</label>
                                                    <div class="input-group input-group-merge">
                                                        <input value={nome} onChange={handleNome} type="text" class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="mb-3 col-md-3">
                                                    <label class="form-label" for="basic-icon-default-fullname">Email do Devedor</label>
                                                    <div class="input-group input-group-merge">
                                                        <input value={email} onChange={handleEmail} type="email" class="form-control" />
                                                    </div>
                                                </div>
                                                {/* <div class="mb-3 col-md-2">
                                                    <label class="form-label" for="basic-icon-default-fullname">CPF do Devedor</label>
                                                    <div class="input-group input-group-merge">
                                                        <input value={cpf} onChange={handleCpf} type="email" class="form-control" />
                                                    </div>
                                                </div> */}
                                                <div class="mb-3 col-md-2">
                                                    <label class="form-label" for="basic-icon-default-fullname">Valor</label>
                                                    <div class="input-group input-group-merge">
                                                        <CurrencyInput value={valor} onChange={handleValor} className="form-control" id="email2" prefix="R$ " decimalSeparator="," thousandSeparator="." />
                                                    </div>
                                                </div>
                                                {chavePix ?
                                                    <div class="mb-3 col-md-12">
                                                        <label class="form-label" for="basic-icon-default-fullname">Chave de Pagamento</label>
                                                        <p>{chavePix}</p>
                                                        <button onClick={()=> handleCopy()} type="submit" className="btn btn-primary me-2">Copiar Chave</button>
                                                    </div>
                                                    :
                                                    null
                                                }

                                                <div className='mb-3 col-md-2' style={{ marginTop: 30 }}>
                                                    <button onClick={() => geraPagamento()} type="submit" className="btn btn-primary me-2">Gerar Cobrança</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
}